<template>
    <section>
        <v-carousel cycle width="100%" show-arrows-on-hover hide-delimiters>
            <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
        </v-carousel>
    </section>
</template>

<script>
export default {
    name: 'about-car',
    data() {
        return {
            items: [
                {
                    src: 'https://images.unsplash.com/photo-1561484930-291119937d44?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
                },
                {
                    src: 'https://images.unsplash.com/photo-1598408745613-178751e2ccde?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2531&q=80',
                },
                {
                    src: 'https://images.unsplash.com/photo-1582033100694-e3727c22436f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
                },
                {
                    src: 'https://plus.unsplash.com/premium_photo-1661954406469-f2ed5ac1e0e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bWFyaW5lfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
                },
            ],
        }
    },
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
</style>